import { useState } from 'react';
import { Box, Link } from '@bigcommerce/big-design';
import { createMarkup } from '../../../../../utils';

export function DescriptionColumn(product) {
	const lengthToCollapseAfter = 400;
	const [collapsed, setCollapsed] = useState(true);
	const text = collapsed
		? product.description?.slice(0, lengthToCollapseAfter)
		: product.description;
	const description = createMarkup(text);

	return (
		<>
			<div dangerouslySetInnerHTML={description} />
			{product.description.length > lengthToCollapseAfter && (
				<Box marginTop="small">
					<Link onClick={() => setCollapsed(!collapsed)}>
						{collapsed ? 'Show More' : 'Show Less'}
					</Link>
				</Box>
			)}
		</>
	);
}
